<template>
  <div class="card-selection" :style="{ width: cardWidth }">
    <!-- <div
      class="card-selection__img"
      :style="{ backgroundImage: `url(${image})` }"
    ></div> -->
    <img :src="image" class="card-selection__img" />
    <div class="card-selection__description">
      <div class="card-selection__description__label">
        <span
          class="card-selection__description__label--title"
          v-html="title"
        ></span>
        <span
          class="card-selection__description__label--subtitle"
          v-if="subtitle"
          v-html="subtitle"
        ></span>
      </div>
      <div class="card-selection__description__info" v-if="info">
        <div class="card-selection__description__info__selection" v-if="time">
          <div class="card-selection__description__info__selection--icon">
            <IconClock
              color="var(--primary-color)"
              :size="30"
              stroke-width="1"
            />
          </div>
          <span class="card-selection__description__info__selection--title">
            {{ time }}
          </span>
        </div>
        <div
          class="card-selection__description__info__selection"
          v-if="location"
        >
          <div class="card-selection__description__info__selection--icon">
            <IconMapPin
              color="var(--primary-40-color)"
              :size="18"
              stroke-width="1"
            />
          </div>
          <span class="card-selection__description__info__selection--title">
            {{ location }}
          </span>
        </div>
        <div
          class="card-selection__description__info__selection"
          v-if="language"
        >
          <div class="card-selection__description__info__selection--icon">
            <IconWorld
              color="var(--primary-color)"
              :size="30"
              stroke-width="1"
            />
          </div>
          <span class="card-selection__description__info__selection--title">
            {{ language }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { IconMapPin, IconClock, IconWorld } from '@tabler/icons-vue'

  const props = defineProps({
    info: { type: Boolean, default: true },
    title: String,
    titleSize: { type: String, default: '32px' },
    subtitle: String,
    subtitleSize: { type: String, default: '20px' },
    time: String,
    location: String,
    language: String,
    image: String,
    width: { type: String, default: '100%' },
    height: { type: String, default: 'auto' },
    imageWidth: { type: String, default: '455px' },
    imageDesktopWidth: { type: String, default: '20%' },
    imageHeight: { type: String, default: '100%' },
    descriptionWidth: { type: String, default: '75%' },
    descriptionDesktopWidth: { type: String, default: '100%' },
    labelGap: { type: String, default: '10px' },
    borderRadius: { type: String, default: '20px' },
    radiusImageLeft: { type: String, default: '20px' },
    radiusImageRight: { type: String, default: '20px' },
    descriptionJustify: { type: String, default: 'center' },
    fit: { type: String, default: 'inherit' }
  })

  const cardWidth = computed(() => props.width)
</script>

<style lang="scss">
  @import '@/scss/variables';

  .card-selection {
    display: flex;
    height: v-bind(height);
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    border-radius: v-bind(borderRadius);
    border: 1px solid #ddd;
    background: var(--theme-color);
    cursor: pointer;
    @media screen and (min-width: $sm-breakpoint) {
      justify-content: flex-start;
      transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    }

    &__img {
      height: v-bind(imageHeight);
      width: v-bind(imageWidth);

      border-top-left-radius: v-bind(radiusImageLeft);
      border-bottom-left-radius: v-bind(radiusImageRight);
      background-size: cover;
      background-position: center;
      object-fit: v-bind(fit);
      @media screen and (min-width: $sm-breakpoint) {
        width: v-bind(imageDesktopWidth);
      }
    }
    &__description {
      display: flex;
      flex-direction: column;
      justify-content: v-bind(descriptionJustify);
      align-items: initial;
      width: v-bind(descriptionWidth);
      padding: 15px;
      gap: 40px;
      align-self: stretch;
      overflow-x: hidden;
      @media screen and (min-width: $sm-breakpoint) {
        width: v-bind(descriptionDesktopWidth);
      }
      &__label {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        gap: v-bind(labelGap);
        &--title {
          font-family: 'OnAir-text-black';
          color: #313235;
          font-size: v-bind(titleSize);
          font-style: normal;
          font-weight: 700;
          line-height: 24px;
          word-wrap: break-word;
          word-break: break-word;
          @media screen and (min-width: $sm-breakpoint) {
            font-size: 1.2rem;
            line-height: 28px;
          }
        }
        &--subtitle {
          color: #86888c;
          font-family: 'OnAir-text-bold';
          font-size: v-bind(subtitleSize);
          font-style: normal;
          font-weight: 400;
          line-height: 16px;
          text-overflow: ellipsis;
          overflow: hidden;

          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          @media screen and (min-width: $sm-breakpoint) {
            overflow: auto;
            text-overflow: unset;
            display: auto;
          }
        }
      }
      &__info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        gap: 10px;
        &__selection {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          gap: 5px;
          &--icon {
            display: flex;
            border-radius: 50px;
            padding: 5px;
            background-color: #e6f5fd;
          }
          &--title {
            color: #313235;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 32px;
          }
        }
      }
    }
  }
</style>
